import axiosInstance from "../Config/axiosConfig";

export const fetchTeachers = async () => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const storedDeviceId = localStorage.getItem("deviceId");
    const storedUserIp = localStorage.getItem("userIp");

    if (!accessToken) {
      throw new Error("Authentication token missing");
    }

    const response = await axiosInstance.get("/admin/get-instructors", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ...(storedDeviceId && { UserDevice: storedDeviceId }),
        ...(storedUserIp && { UserIPAddress: storedUserIp }),
      },
    });

    // Normalize the response data
    let teachersData = [];
    console.log("Response data:", response.data);
    if (Array.isArray(response.data)) {
      teachersData = response.data;
    } else if (response.data && Array.isArray(response.data.instructors)) {
      teachersData = response.data.instructors;
    } else if (response.data && response.data.data) {
      teachersData = Array.isArray(response.data.data) ? response.data.data : [response.data.data];
    } else {
      teachersData = [response.data];
    }

    return teachersData;
  } catch (error) {
    console.error("Error fetching teachers:", error);
    throw error;
  }
};